import clsx from 'clsx';

import { VoucherType, PromotionType } from '@/types';

export const EventVoucherIcon = ({
	voucherType,
	className,
	isGift = false,
	promotionInfo,
}: {
	voucherType: number;
	className?: string;
	isGift?: boolean;
	promotionInfo?: {
		Id: number;
		ResourceKey: string | null;
		ResourceName: string | null;
		ShowHint: boolean;
		PromotionType: number;
	};
}) => {
	const iconClassName = {
		[VoucherType.OddsBooster]: 'reward-icon-voucher-oddsboost',
		[VoucherType.RiskFreeBet]: 'reward-icon-voucher-shield',
		[VoucherType.CashExchange]: 'reward-icon-voucher-exchange',
		[VoucherType.NicknameChange]: 'reward-icon-voucher-edit',
		[VoucherType.FreeOddsBooster]: 'reward-icon-voucher-oddsboost-promo',
		[VoucherType.NicknameChange]: 'reward-icon-voucher-edit',
		[VoucherType.BetterCashExchange]: 'reward-icon-voucher-exchange',
		[VoucherType.BestCashExchange]: 'reward-icon-voucher-exchange',
		[VoucherType.NewRiskFreeBet]: 'reward-icon-voucher-shield',
		[VoucherType.AffPromotionOddsBoost]: 'reward-icon-voucher-oddsboost-promo',
		[VoucherType.StandardCashExchange]: 'reward-icon-voucher-exchange',
		[VoucherType.GoodCashExchange]: 'reward-icon-voucher-exchange',
		[VoucherType.GiftRiskFreeBet]: 'reward-icon-voucher-shield',
		[VoucherType.FreeBet]: 'reward-icon-voucher-free-bet' ,
	}[voucherType] ?? null;
	const isCustomizedFreeBet = voucherType === VoucherType.FreeBet
		&& promotionInfo?.PromotionType === PromotionType.Customized;

	return (
		<i
			className={clsx(iconClassName, className, {
				'reward-icon-voucher--gift': isGift,
				'reward-icon-voucher--gift--customized': isGift && isCustomizedFreeBet,
			})}
		/>
	);
};